import { createContext } from 'react';

export interface SocialOSContextType {
    energy: number;
    xp: number;
    level: number;
    theme: string;
    isCommandHubOpen: boolean;
    setIsCommandHubOpen: (open: boolean) => void;
    isAIOpen: boolean;
    setIsAIOpen: (open: boolean) => void;
    addXP: (amount: number) => void;
    consumeEnergy: (amount: number) => boolean;
}

export const SocialOSContext = createContext<SocialOSContextType | undefined>(undefined);
